import { h, Component } from "preact";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import Spinner from "../../../common/components/Spinner";
import IconBell from "../../../common/components/icons/IconBell";
import IconBellSolid from "../../../common/components/icons/IconBellSolid";
import IconCalendarPlus from "../../../common/components/icons/IconCalendarPlus";
import IconChartBar from "../../../common/components/icons/IconChartBar";
import IconInfoCircle from "../../../common/components/icons/IconInfoCircle";
import {
    urlFactory,
    downloadCalendar,
    formatTemplate,
    getDateString,
} from "../../helpers";
import { GTM_ID, GA4EVENT } from "../../constants";
import actions from "../../actions";
import { CALENDAR_VIEW } from "../../../calendar-common/constants";
import { RELATED_NEWS_VIEW } from "../../../calendar-common/constants/relatedNewsView";
import IconAngleDoubleRight from "../../../common/components/icons/IconAngleDoubleRight";
import CalendarPosts from "../../../calendar-common/components/CalendarPosts";
import { getPeriodType } from "../../../calendar-common/helpers/periodTypeHelper";
import { enabledCalendarNotifications } from "../../../calendar-common/helpers/calendar";
import SpeechTrackerModal from "../../components/modal/SpeechTrackerModal";
import SpeechScore from "./SpeechScore";
import SpeechAverageScore from "./SpeechAverageScore";
import eventTimeCheck from "../../helpers/eventTimeCheck";
import { getSpeechScore } from "../../helpers/getSpeechScore";

const BasicCellNumber = "10";
const DefaultCellNumber = "11";

class EventRowDetailDesktop extends Component {
    constructor(props) {
        super(props);
        this.renderDetail = this.renderDetail.bind(this);
        this.state = {
            showSpeechTrackerModal: false,
        };
    }

    toggleSpeechTrackerModal = () => {
        this.setState((prevState) => ({
            showSpeechTrackerModal: !prevState.showSpeechTrackerModal,
        }));
    };

    renderError() {
        const {
            translate,
            settings: { view },
        } = this.props;

        return (
            <tr>
                <td
                    colspan={
                        view == CALENDAR_VIEW.Configure_View_Basic
                            ? BasicCellNumber
                            : DefaultCellNumber
                    }
                >
                    {translate("DetailEventFetchError")}
                </td>
            </tr>
        );
    }

    renderFetching() {
        const {
            settings: { view },
        } = this.props;

        return (
            <tr>
                <td
                    colspan={
                        view == CALENDAR_VIEW.Configure_View_Basic
                            ? BasicCellNumber
                            : DefaultCellNumber
                    }
                >
                    <Spinner />
                </td>
            </tr>
        );
    }

    renderComments(eventDateDetailData) {
        const { translate, config } = this.props;

        return (
            <div>
                <h2 class="fxs_headline_small">
                    {translate("DetailEventDateDescription")}
                </h2>
                {eventDateDetailData.headline && (
                    <p class="fxs_txt_size_small">
                        <strong>{eventDateDetailData.headline}</strong>
                    </p>
                )}
                <p
                    class="fxs_txt_size_small"
                    dangerouslySetInnerHTML={{
                        __html: eventDateDetailData.comments,
                    }}
                ></p>
                {eventDateDetailData.link && (
                    <a
                        href={eventDateDetailData.link}
                        class="fxs_fRight fxs_txt_size_xsmall"
                        data-gtmid={
                            config.tracking &&
                            GTM_ID.OPEN_READFULLREPORT(eventDateDetailData.id)
                        }
                        data-ga4event-clk-name={
                            config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                        }
                        data-ga4event-element={
                            config.tracking && GA4EVENT.ELEMENTS.OPEN_READFULLREPORT
                        }
                        data-ga4event-eventdateid={eventDateDetailData.id}
                    >
                        {translate("DetailEventReadFullReport")}
                        <IconAngleDoubleRight />
                    </a>
                )}
            </div>
        );
    }

    renderDescription(eventDateDetailData, eventDateRelatedNews) {
        const { config } = this.props;
        return (
            <div className="fxs_c_description_wrapper">
                <p
                    class="fxs_txt_size_small"
                    data-gtmid={
                        config.tracking && GTM_ID.OPEN_LINK_TEXT(eventDateDetailData.id)
                    }
                    data-ga4event-clk-name={
                        config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                    }
                    data-ga4event-element={
                        config.tracking && GA4EVENT.ELEMENTS.OPEN_LINK_TEXT
                    }
                    data-ga4event-eventdateid={eventDateDetailData.id}
                    dangerouslySetInnerHTML={{
                        __html: eventDateDetailData.description,
                    }}
                ></p>
            </div>
        );
    }

    renderWhyMatters(eventDateDetailData) {
        const { translate } = this.props;

        return (
            <div class="fxs_c_matters_traders">
                <h2 class="fxs_headline_small">
                    {translate("DetailEventDateMattersTradersTitle")}
                </h2>
                <p
                    class="fxs_txt_size_small"
                    dangerouslySetInnerHTML={{
                        __html: eventDateDetailData.whyMatters,
                    }}
                ></p>
            </div>
        );
    }
    renderDetailTable(eventDateDetailData) {
        const { translate, config } = this.props;

        return (
            <div class="fxs_c_detail_table fxs_txt_size_xsmall">
                {eventDateDetailData.source && (
                    <div class="fxs_c_detail_table_row ">
                        <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                            <strong>{translate("DetailEventDateSourceLabel")}</strong>
                        </div>
                        <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                            <strong>
                                {eventDateDetailData.urlSource ? (
                                    <a
                                        href={eventDateDetailData.urlSource}
                                        target="_blank"
                                        data-gtmid={
                                            config.tracking &&
                                            GTM_ID.OPEN_SOURCE(eventDateDetailData.id)
                                        }
                                        data-ga4event-clk-name={
                                            config.tracking &&
                                            GA4EVENT.NAMES.FEATURES_CALENDAR
                                        }
                                        data-ga4event-element={
                                            config.tracking &&
                                            GA4EVENT.ELEMENTS.OPEN_SOURCE
                                        }
                                        data-ga4event-eventdateid={eventDateDetailData.id}
                                    >
                                        {eventDateDetailData.source}
                                    </a>
                                ) : (
                                    <span>{eventDateDetailData.source}</span>
                                )}
                            </strong>
                        </div>
                    </div>
                )}

                <div class="fxs_c_detail_table_row ">
                    <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                        <strong>{translate("DetailEventFrequency")}</strong>
                    </div>
                    <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                        {getPeriodType(eventDateDetailData.periodType, translate)}
                    </div>
                </div>
                {eventDateDetailData.nextReleaseDate && (
                    <div class="fxs_c_detail_table_row ">
                        <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                            <strong>{translate("DetailEventNextRelease")}</strong>
                        </div>
                        <div class="fxs_c_detail_table_cell fxs_paddingHalf_bottom">
                            {getDateString(
                                new Date(eventDateDetailData.nextReleaseDate),
                                config.culture
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    renderSpeechScore({ isSpeechScoreLocked, speechScore, hasSpeechData, isInProgress }) {
        const { translate } = this.props;

        return (
            <>
                {isSpeechScoreLocked && (
                    <>
                        <p class="fxs_c_unlock">
                            <span>{translate("DetailEventDateUnlock")}</span>
                            <a
                                href="/account/login?uriToRedirect=%2Feconomic-calendar%3Fuser_action%3Dlogin"
                                class="fxs_c_unlock_btn"
                                data-ga4event-clk-name="features-calendar_click"
                                data-ga4event-element="log-in"
                            >
                                {translate("LogIn")}
                            </a>
                        </p>
                        <p
                            class="fxs_c_speed_tracker_mean"
                            onClick={this.toggleSpeechTrackerModal}
                        >
                            <IconInfoCircle />
                            <span>{translate("SpeechTrackerMean")}</span>
                        </p>
                    </>
                )}
                {!isSpeechScoreLocked && hasSpeechData && (
                    <div className="fxs_c_speech_score_detail_wrapper">
                        {speechScore?.isVotingMember != null && (
                            <p class="fxs_c_speech_tracker_score">
                                <span>{translate("VotingMember").concat(": ")}</span>
                                <span className="fxs_c_speech_score">
                                    {speechScore?.isVotingMember ? "Yes" : "No"}
                                </span>
                            </p>
                        )}
                        <p class="fxs_c_speech_tracker_score">
                            <span>
                                {translate("SpeechTrackerScoreLabel").concat(": ")}
                            </span>
                            {speechScore?.score ? (
                                <SpeechScore speechScore={speechScore} />
                            ) : isInProgress ? (
                                <span className="fxs_c_speech_score_label">
                                    {translate("InProgress")}
                                </span>
                            ) : (
                                <span className="fxs_c_speech_score">-</span>
                            )}
                        </p>
                        <p class="fxs_c_speech_tracker_score">
                            <span>{translate("Average").concat(": ")}</span>
                            <SpeechAverageScore
                                speechScore={speechScore}
                                includeLabel={true}
                            />
                        </p>
                    </div>
                )}
            </>
        );
    }

    renderDetail(eventDateDetailData, eventDateRelatedNews, eventTimeReached) {
        const {
            canBeSubscribed,
            isSubscribed,
            subscribeToEvent,
            unsubscribeToEvent,
            translate,
            config,
            showEventNotifyModal,
            settings: { timezoneOffset, view },
            event,
            eventDateDetails,
        } = this.props;

        const showDashIcon =
            config.dashboardUrl &&
            !(
                eventDateDetailData.isSpeech ||
                eventDateDetailData.isReport ||
                eventDateDetailData.isAllDay
            );

        let speechScore = null;
        let isSpeechScoreLocked = false;

        const isSpeech = event?.isSpeech ?? false;
        const hasScore = event?.speech?.score ?? false;
        const hasSpeechData =
            event?.speech?.score ?? event?.speech?.averageScore ?? false;

        const isSpeechScoreEnabled = config.enableSpeechScore;

        const isInProgress =
            !hasScore &&
            event?.isScoreTrackable &&
            eventTimeReached &&
            isSpeechScoreEnabled;

        if (isSpeech && isSpeechScoreEnabled && hasSpeechData) {
            speechScore = getSpeechScore(event);
            isSpeechScoreLocked = config.isLocked();
        }

        return (
            <tr>
                <td
                    colspan={
                        view == CALENDAR_VIEW.Configure_View_Basic
                            ? BasicCellNumber
                            : DefaultCellNumber
                    }
                    class="fxs_c_detail"
                >
                    {isSpeechScoreEnabled &&
                        this.renderSpeechScore({
                            isSpeechScoreLocked,
                            speechScore,
                            hasSpeechData,
                            isInProgress,
                        })}
                    {this.state.showSpeechTrackerModal && (
                        <SpeechTrackerModal
                            toggleSpeechTrackerModal={this.toggleSpeechTrackerModal}
                        />
                    )}
                    <div class="fxs_c_action_buttons fxs_fRight">
                        <button
                            type="button"
                            data-gtmid={
                                config.tracking &&
                                GTM_ID.ADD_EVENT(eventDateDetailData.id)
                            }
                            data-ga4event-clk-name={
                                config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                            }
                            data-ga4event-element={
                                config.tracking && GA4EVENT.ELEMENTS.ADD_EVENT
                            }
                            data-ga4event-eventdateid={eventDateDetailData.id}
                            onClick={() =>
                                downloadCalendar(
                                    urlFactory.getEventDateICalendar(
                                        config,
                                        eventDateDetailData.id
                                    ),
                                    "text/calendar"
                                )
                            }
                            class="fxs_c_detail_action_button fxs_c_tooltip_action"
                        >
                            <IconCalendarPlus />
                            <span class="fxs_c_content">
                                <span class="fxs_c_textnode">
                                    {translate("AddEvent")}
                                </span>
                            </span>
                        </button>
                        {showDashIcon && (
                            <a
                                href={formatTemplate(config.dashboardUrl, {
                                    eventId: eventDateDetailData.eventId,
                                    timezoneOffset,
                                })}
                                class="fxs_c_detail_action_button  fxs_c_tooltip_action"
                                data-gtmid={
                                    config.tracking &&
                                    GTM_ID.OPEN_DASHBOARD(eventDateDetailData.id)
                                }
                                data-ga4event-clk-name={
                                    config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                                }
                                data-ga4event-element={
                                    config.tracking && GA4EVENT.ELEMENTS.OPEN_DASHBOARD
                                }
                                data-ga4event-eventdateid={eventDateDetailData.id}
                                target="_blank"
                            >
                                <IconChartBar />
                                <span class="fxs_c_content">
                                    <span class="fxs_c_textnode">
                                        {translate("Dashboard")}
                                    </span>
                                </span>
                            </a>
                        )}

                        {canBeSubscribed && enabledCalendarNotifications(config) && (
                            <button
                                type="button"
                                class={`fxs_c_detail_action_button fxs_subscribe fxs_c_tooltip_action
                            ${isSubscribed ? "fxs_c_detail_action_button_active" : ""}
                        `}
                                data-gtmid={
                                    config.tracking && isSubscribed
                                        ? GTM_ID.NOTIFY_ME_UNSUBSCRIPTION(
                                              eventDateDetailData.id
                                          )
                                        : GTM_ID.NOTIFY_ME_SUBSCRIPTION(
                                              eventDateDetailData.id
                                          )
                                }
                                data-ga4event-clk-name={
                                    config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                                }
                                data-ga4event-element={
                                    config.tracking && isSubscribed
                                        ? GA4EVENT.ELEMENTS.NOTIFY_ME_UNSUBSCRIPTION
                                        : GA4EVENT.ELEMENTS.NOTIFY_ME_SUBSCRIPTION
                                }
                                data-ga4event-eventdateid={eventDateDetailData.id}
                                onClick={() => {
                                    if (isSubscribed)
                                        unsubscribeToEvent(eventDateDetailData.eventId);
                                    else {
                                        subscribeToEvent(eventDateDetailData.eventId);
                                    }
                                }}
                            >
                                {isSubscribed && enabledCalendarNotifications(config) ? (
                                    <IconBellSolid />
                                ) : (
                                    <IconBell />
                                )}
                                <span class="fxs_c_content">
                                    <span class="fxs_c_textnode">
                                        {translate("NotifyMe")}
                                    </span>
                                </span>
                            </button>
                        )}
                    </div>
                    <div class="fxs_clearfix"></div>
                    <div class="fxs_c_detail_top_row">
                        <div
                            class={`fxs_c_detail_half_block ${
                                eventDateDetailData.comments
                                    ? "fxs_c_detail_comments"
                                    : ""
                            }`}
                        >
                            {eventDateDetailData.comments
                                ? this.renderComments(eventDateDetailData)
                                : eventDateDetailData.whyMatters
                                ? this.renderWhyMatters(eventDateDetailData)
                                : this.renderDescription(
                                      eventDateDetailData,
                                      eventDateRelatedNews
                                  )}
                        </div>
                        <div class="fxs_c_detail_half_block">
                            {this.renderDetailTable(eventDateDetailData)}
                            {(eventDateDetailData.comments ||
                                eventDateDetailData.whyMatters) &&
                                this.renderDescription(
                                    eventDateDetailData,
                                    eventDateRelatedNews
                                )}
                        </div>
                    </div>
                    <div class="fxs_clearfix"></div>

                    {eventDateDetailData.comments &&
                    eventDateDetailData.whyMatters &&
                    eventDateRelatedNews ? (
                        <div class="fxs_c_detail_bottom_row">
                            <div class="fxs_c_detail_half_block">
                                {this.renderWhyMatters(eventDateDetailData)}
                            </div>
                            {eventDateRelatedNews && (
                                <CalendarPosts
                                    view={RELATED_NEWS_VIEW.View_Half}
                                    wrapperClass="fxs_c_detail_half_block"
                                    posts={eventDateRelatedNews.data}
                                    isFetching={eventDateRelatedNews.isFetching}
                                    fetchError={eventDateRelatedNews.fetchError}
                                    RelatedNewsTranslation={translate("RelatedNewsTitle")}
                                    ByAuthorTranslation={translate("ByAuthor")}
                                    ErrorTranslation={translate("ErrorFetchingNews")}
                                    culture={config.culture}
                                    customPostUrl={config.customPostUrl}
                                />
                            )}
                        </div>
                    ) : (
                        eventDateRelatedNews && (
                            <div
                                class="fxs_c_detail_bottom_row"
                                data-gtmid={
                                    config.tracking &&
                                    GTM_ID.OPEN_RELATEDNEWS(eventDateDetailData.id)
                                }
                                data-ga4event-clk-name={
                                    config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                                }
                                data-ga4event-element={
                                    config.tracking && GA4EVENT.ELEMENTS.OPEN_RELATEDNEWS
                                }
                                data-ga4event-eventdateid={eventDateDetailData.id}
                            >
                                <CalendarPosts
                                    view={RELATED_NEWS_VIEW.View_Grid}
                                    wrapperClass="fxs_c_detail_half_block"
                                    posts={eventDateRelatedNews.data}
                                    isFetching={eventDateRelatedNews.isFetching}
                                    fetchError={eventDateRelatedNews.fetchError}
                                    RelatedNewsTranslation={translate("RelatedNewsTitle")}
                                    ByAuthorTranslation={translate("ByAuthor")}
                                    ErrorTranslation={translate("ErrorFetchingNews")}
                                    culture={config.culture}
                                    customPostUrl={config.customPostUrl}
                                />
                            </div>
                        )
                    )}
                </td>
            </tr>
        );
    }

    render(
        { event, eventDateDetails, eventDateDetailShown, relatedNews, eventTimeReached },
        {}
    ) {
        const { id } = event;

        const isVisible = eventDateDetailShown && eventDateDetailShown === id;
        const eventDateDetail = eventDateDetails.hasOwnProperty(id)
            ? eventDateDetails[id]
            : null;

        const eventDateNews = relatedNews.hasOwnProperty(id) ? relatedNews[id] : null;

        if (!isVisible || !eventDateDetail) {
            return null;
        }
        if (eventDateDetail.error) {
            return this.renderError();
        }
        if (eventDateDetail.isFetching) {
            return this.renderFetching();
        }

        return this.renderDetail(eventDateDetail.data, eventDateNews, eventTimeReached);
    }
}

export default connectWithTranslations(
    "eventDateDetails,eventDateDetailShown,config,settings, relatedNews",
    actions
)(eventTimeCheck(EventRowDetailDesktop));
